module.exports = __webpack_public_path__ + "static/img/ygfc1.5e2f709.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/ygfc1.png
// module id = uFK7
// module chunks = 2